module.exports = __webpack_public_path__ + "img/jour.2a66ce51.gif";